import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { HttpClient, HttpResponse } from '@angular/common/http';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';


@Component({
  selector: 'app-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.css', '../../Components/login-sign-up/login-sign-up.component.scss']
})
export class LinkComponent implements OnInit {
  email = "";
  password = "";
  header = {
    'accept': 'application/json',
    'content-Type': 'application/json',
    "token-type": '',
    "client": '',
    "access-token": '',
    "uid": ''
  } 
  base = 'https://outreach.iiw.org/api/v1'
  orgs = []
  selectedOrg;
  isLinear = false;
  firstFormGroup: FormGroup;
  stepper
  logginIn = false
  loginMessage = "Login"
  constructor(private location: Location, private http: HttpClient, private _formBuilder: FormBuilder) {}

  ngOnInit() {
    this.firstFormGroup = this._formBuilder.group({
      emailCtrl: ['', Validators.required],
      passwordCtrl: ['', Validators.required]
    });

  }

  goBack = () => {
    this.location.back()
  }

  setSelectedOrg = (org) => {
    this.selectedOrg = org
  }

  login = async (stepper) => {
    if(this.logginIn){
      return
    }
    this.loginMessage = "Processing..."
    this.logginIn = true
    this.stepper = stepper
    this.http.post(
      this.base + '/auth/sign_in.json',
      {
        email: this.email,
        password: this.password
      },  
      {
        headers: this.header,
        observe: 'response'
      } )
      .take(1)
      .subscribe(
        this.onLogin,
        this.onLoginError,
        () => {}
      )

  }
  onLoginError = (e) => {
    if(e.status === 401){
      alert("Either your Email or Password are incorrect")
    }
    this.resetLogin()
    // console.error(e)
  }

  getOrgs = () => {
    this.http.get(
      this.base + '/orgs', {
        headers: this.header,
        observe: 'response'
      })
      .take(1)
      .subscribe(
        this.onOrgLoad,
        console.error,
        () => {}
      )

  }

  onOrgLoad = (response) => {
    this.saveHeaders(response)
    this.orgs = response.body
    // console.log(response.body)
    this.stepper.next()
  }

  resetLogin = () => {
    this.logginIn = false
    this.loginMessage = "Login"
  }

  onLogin = (response) => {
    
    this.resetLogin()
      this.saveHeaders(response)  
      this.getOrgs()    
  }

  saveHeaders = (response) => {
    this.header['access-token'] =  response.headers.get('access-token')
    this.header['uid'] =  response.headers.get('uid')
    this.header['client'] =  response.headers.get('client')
    this.header['token-type'] =  response.headers.get('token-type')
  }

}
